export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://lisaserver-44223616ba78.herokuapp.com";
